/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-11-05
 * @brief EHP 이메일 상담 관리 개발
 *
 ********************************************************************/
import React, { useState } from "react";
import clog from "../../../utils/logUtils";
//component
import EconsultCRUD from "./EconsultCRUD";
/**
 * @brief EHP 이메일 상담 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function EconsultMain(props) {
    //
    const [isMobile, setIsMobile] = useState(false);
    const [adminType, setAdminType] = useState("EMAIL"); // CHECK, ERROR, HTTP
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH, SET
    const [workMode, setWorkMode] = useState("LIST");
    const defaultTree = {
        menu: { menuId: "", menuName: "" },
        reload: false
    };
    const [selTree, setSelTree] = useState(defaultTree);
    function handleSelTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setAdminType(adminType);
        setSelTree(treeInfo);
    }
    return (React.createElement(React.Fragment, null, (adminType === "EMAIL") && React.createElement(EconsultCRUD, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin, handleNodata: props.handleNodata })));
}
export default EconsultMain;
